import React from 'react';
import { BookOpen, Package, Star, Award } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Award className="w-5 h-5 text-[#c8971b]" data-id="element-301" />,
    text: '+300 docentes'
  }, {
    icon: <BookOpen className="w-5 h-5 text-[#c8971b]" data-id="element-302" />,
    text: '6 Tomos completos'
  }, {
    icon: <Package className="w-5 h-5 text-[#c8971b]" data-id="element-303" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-[#c8971b] fill-[#c8971b]" data-id="element-304" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-[#1e4230] border-y-2 border-[#c8971b]/40 py-6" data-id="element-305">
      <div className="container mx-auto px-4" data-id="element-306">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-307">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-semibold text-[#f0e9d6]" data-id="element-308">
              {stat.icon}
              <span data-id="element-309">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}